import axiosWithAuth from '../utils/axiosWithAuth';
import { getApiEndpoint } from '../utils/apiConfig';

// Get all repair tariffs (admin)
export const getAllRepairTariffs = async () => {
  try {
    const response = await axiosWithAuth().get(getApiEndpoint('repair-tariffs/admin'));
    console.log('Repair tariffs response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching repair tariffs:', error);
    throw error;
  }
};

// ID'ye göre Repair Tariff getir
export const getRepairTariff = async (id) => {
  try {
    const response = await axiosWithAuth().get(getApiEndpoint(`repair-tariffs/${id}`));
    return response.data;
  } catch (error) {
    console.error(`Error fetching repair tariff ${id}:`, error);
    throw error;
  }
};

// Yeni Repair Tariff ekle
export const createRepairTariff = async (data) => {
  try {
    const response = await axiosWithAuth().post(getApiEndpoint('repair-tariffs'), data);
    return response.data;
  } catch (error) {
    console.error('Error creating repair tariff:', error);
    throw error;
  }
};

// Repair Tariff güncelle
export const updateRepairTariff = async (id, data) => {
  try {
    const response = await axiosWithAuth().put(getApiEndpoint(`repair-tariffs/${id}`), data);
    return response.data;
  } catch (error) {
    console.error(`Error updating repair tariff ${id}:`, error);
    throw error;
  }
};

// Repair Tariff sil
export const deleteRepairTariff = async (id) => {
  try {
    const response = await axiosWithAuth().delete(getApiEndpoint(`repair-tariffs/${id}`));
    return response.data;
  } catch (error) {
    console.error(`Error deleting repair tariff ${id}:`, error);
    throw error;
  }
}; 